import { render, staticRenderFns } from "./CustomerDepartmentRegister.vue?vue&type=template&id=4f5d4930&"
import script from "./CustomerDepartmentRegister.vue?vue&type=script&lang=ts&"
export * from "./CustomerDepartmentRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports